import { Component } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";

@Component({
	selector: "app-maintenance",
	imports: [NgOptimizedImage],
	templateUrl: "./maintenance.component.html"
})
export class MaintenanceComponent {}
